module.exports = __webpack_public_path__ + "static/img/home_1.b71ed1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_1.png
// module id = gh75
// module chunks = 0